import { observer } from "mobx-react";
import logo from "../assets/locht-logo.svg";

const Footer = observer(() => {
  return (
    <footer className="py-3 border-top container-fluid px-0">
      <div className="d-flex justify-content-center">
        <a href="http://estudiolocht.com/">
          <img src={logo} alt="Logo" />
        </a>
      </div>
    </footer>
  );
});
export default Footer;
